import Request from "../../lib/request";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import {
  DASHBOARD_API,
  GET_CASH_REMAIN_API,
  GET_CLASSIFICATION_API,
  GET_IMAGE_API, GET_PAYMENT_API,
  PROJECT_USERS_API
} from "../../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const pettyCashierGetTwoNumbers = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_IMAGE_API}`,
    needToken: true
  });
};

export const pettyCashierGetCashRemain = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_CASH_REMAIN_API}`,
    needToken: true
  });
};

export const pettyCashierGetClassification = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_CLASSIFICATION_API}`,
    needToken: true
  });
};

export const pettyCashierGetPayment = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${DASHBOARD_API}/${GET_PAYMENT_API}`,
    needToken: true
  });
};
